import React from 'react'
import { useSelector } from 'react-redux'
import { LineChart } from 'components/Charts'
import { MARKETING, HEADER } from 'constants/forioVariables'
import { CONSTANTS } from 'constants/constants'

const { MARKET_SHARE_PURETE_SMOOTHED } = MARKETING
const { TIME } = HEADER
const { POPULAR_SEGMENT } = CONSTANTS

const returnData = (variables, time) => {
  return {
    labels: time ? time[TIME] : [0],
    datasets: [
      {
        label: POPULAR_SEGMENT,
        fill: false,
        borderColor: '#4bc0c0',
        data: variables[MARKET_SHARE_PURETE_SMOOTHED],
      },
    ],
  }
}

const ChartPopularSegment = () => {
  const variables = useSelector(
    state => state.marketing.currentValues.variablesChartPopularSegments,
  )
  const time = useSelector(state => state.header.variablesHeader)
  return time && time[TIME] ? (
    <LineChart
      data={returnData(variables, time)}
      titleColor="#9E8585"
      titleChart="Popular Segment"
    />
  ) : null
}
export default ChartPopularSegment
